/**
 * Navigation Module
 * Handles mobile navigation menu
 */

export function initNavigation() {
    
    /***************************************
     *     Trigger mobile Nav
     ***************************************/
    const triggerMenu = document.getElementById('trigger-menu');
    const offCanvasNav = document.getElementById('off-canvas-nav');

    if (triggerMenu && offCanvasNav) {
        triggerMenu.addEventListener('click', function() {
            this.classList.toggle('is-active');
            offCanvasNav.classList.toggle('opened');
        });
    }
    
    
    setTimeout(() => {
        document
        .getElementById('main-wrapper')
        ?.classList.add('is-visible');
    }, 50);
    
    
    function markLastGridRow(gridSelector, className = 'is-last-row') {
        const grid = document.querySelector(gridSelector);
        if (!grid) return;
        
        const items = Array.from(grid.children);
        if (!items.length) return;

        // cleanup (useful if recalculating)
        items.forEach(el => el.classList.remove(className));

        // offsetTop of the last element
        const lastRowTop = items[items.length - 1].offsetTop;

        // all items with the same offsetTop are in the last row
        items.forEach(el => {
            if (el.offsetTop === lastRowTop) {
                el.classList.add(className);
            }
        });
    }
    
    
    markLastGridRow('.news-wrapper');
    
    window.addEventListener('resize', () => {
        markLastGridRow('.news-wrapper');
    });
    
}
